module.exports = __webpack_public_path__ + "img/re_vagas.96246847.png";